import { GridCol, mixins, styled } from '@bob/library'

export const Title = styled.h2`
  ${mixins.typography.headlineSmall}
  ${mixins.margin.bottom(40)}
`

export const Wrapper = styled(GridCol)`
  ${mixins.margin.bottom(20)}
`

export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('blue')}
  ${mixins.padding.left(0)}
`
export const StyledHR = styled.hr`
  border: 1px solid ${mixins.colors.grayLowlight};
  ${mixins.margin(0, 0, 25)}
`
export const StyledTitle = styled.h3`
  ${mixins.margin(0)}
`
